module.exports = __webpack_public_path__ + "img/undraw_shop.ec48f326.svg";